import { render } from "./HeroConsult.vue?vue&type=template&id=1df7e520&scoped=true"
import script from "./HeroConsult.vue?vue&type=script&lang=js"
export * from "./HeroConsult.vue?vue&type=script&lang=js"

import "./HeroConsult.vue?vue&type=style&index=0&id=1df7e520&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1df7e520"]])

export default __exports__